// @flow
import { uniqueId } from "lodash";
import Immutable from "seamless-immutable";
import consts from "../common/consts";

export const createFileData = (data: Object) => Immutable({
	id: "",
	batchId: "",
	name: "",
	size: 0,
	type: "",
	folder: "",
	imageDimensions: [0, 0],
	status: null,
	progress: 0,
	done: false,
	failed: false,
	aborted: false,
	paused: false,
	partOfBatch: false,
	publicId: "",
	preparedParams: {},
	camera: false,
	customCoordinates: null,
	coordinatesResize: false,
	// flag used when coordinates are updated during upload process
	// flag used by uploadCallbacks to determine whether pre-calls (prepare, pre-batch) were delayed due to resize/orientation
	// affecting signature for signed upload
	delayedPreCalls: false,
	...data, // allows overriding file data when creating it
});

export const createUploadQueue = (data: Object) => Immutable({
	queueId: uniqueId("u-queue"),
	config: null,
	configOverride: null,
	sameConfig: false,
	files: {},
	filesData: {},
	ids: [],
	status: consts.QUEUE_STATUS.NONE,
	pendingPreCalls: false,
	metadata: null,
	retryQueue: false,
	...data, // allows overriding queue data when creating it
});

export default () => Immutable({
	__record: "UploaderRecord",
	id: null, // the widget id sent from the client, must be set for the PM-COMMS to work
	showOnStart: false, // whether to show the widget when it's first loaded
	qsParams: null, // query string params used to open the widget's iframe
	// the cloud info downloaded for the cloud name (premium) -
	// {"data-premium":0,"data-cname":null,"data-private-cdn":false,"data-secure-distribution":"res.cloudinary.com"}
	cloudInfo: null,
	source: null, // option source requested by the client when making a show request
	showCounter: 0, // keeps track of show requests by client
	minimizeCounter: 0, // keeps track minimize requests by client
	showOptions: null, // show options from client (only 'fileDialog' currently)
	hideCounter: 0, // keeps track of hide requests by client
	hideOptions: null, // hide options form client (only 'quiet' currently)
	queues: [], // the upload queues maintained internally by the uploader
	retrievedTags: [], // the tags retrieved from the optional callback that client may pass to the widget
	retrievedUploadPresets: [], // the upload presets retrieved from the optional callback that client may pass to the widget
	uploadPublicId: null, // the public id to use for the upload
	uploadTags: [], // the tags to use for the upload
	uploadPreset: null, // the upload presets to use for the upload
	clientUploadBatches: [],
	fileQueueIndex: {}, // key is the file id, value is the queue index - makes it easy to locate a file within the queues
	fileVersions: {}, // key is the file id, value is the latest version marking how many updated occurred on the file
	publicIdCounters: {}, // registry for the last counter seen per public id
	onDevConsole: false, // whether widget is loaded by cloudinary's console on dev env
	onConsole: false, // whether widget is loaded by cloudinary's console (any env)
	successCounter: 0, // counter of successful uploads for this instance
	clearQueuesInProgress: false, // flag to determine if currently in the process of clearing the queues
	cropSources: [], // hold the crop source for the crop view.
	postBatchCleanList: [], //list of state props to reset after upload finishes
});
